// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  apim: window['env']['apim'],
  authority: window['env']['authority'],
  knownAuthorities: window['env']['knownAuthorities'],
  authScopes: window['env']['authScopes'],
  clientid: window['env']['clientid'],
  envTag: window['env']['envTag'],
  production: window['env']['production'],
  redirecturl: window['env']['redirecturl'],
  userRefreshIntervalInSeconds: window['env']['userRefreshIntervalInSeconds'],
  googleGeocode: window['env']['googleGeocode'],
  blobStorage: window['env']['blobStorage'],
  environment: window['env']['environment'],
  pciPal: window['env']['pciPal'],
};
